import { create } from 'zustand';
import { SectionKeys, TextTypeKeys, TimeSlot } from '../../../constant';
import { ApplicantResponse } from '../../../model/tasklist_response';
import { createDI } from '../../../context/di/di';
import { ApiError, ApiResponse, useApi } from '../../../api/api';
import { toQuery } from '../../../utils/url_utils';
import { ConflictStatusResponse } from '../../../model/conflict_status_response';
import { WorkListReponse } from '../../../model/work_response';

/**
 * 作業競合一覧取得リクエストParam
 */
export type TaskListParam = {
  sections?: SectionKeys[];
  division?: number;
  floor?: number;
  block?: number;
  applyDateType: 'none' | 'range' | 'day';
  apply_from?: string;
  apply_to?: string;
  workDateType: 'none' | 'range' | 'day';
  work_from?: string;
  work_to?: string;
  timeType: 'none' | 'range' | 'timeSlot';
  start_time?: string;
  end_time?: string;
  span_of_time?: TimeSlot;
  textType?: TextTypeKeys;
  content?: string;
  count: number;
};

/**
 * 作業競合確認画面 アクションを管理するための DI コンテキスト(アクション)
 */
export type TaskListAction = {
  /**
   * 競合チェック開始
   */
  checkConflict: () => Promise<void>;

  /**
   * 競合ステータス取得
   */
  getConflictStatus:() => Promise<ConflictStatusResponse>;

  /**
   * 作業競合一覧取得
   * @param param
   */
  searchTaskList: (param: TaskListParam) => Promise<ApplicantResponse>;

  /**
   * 競合情報取得
   * @param conflictId
   * @param planId
   */
  getConflict:(conflictId: number, planId: number) => Promise<WorkListReponse>;
};

/**
 * 作業競合確認画面 状態とアクションを管理するための DI コンテキスト
 */
export type TaskListStore = TaskListAction;

/**
 * 作業競合確認画面 状態とアクションを管理するための DI コンテキストを作成
 */
const [Provider, use] = createDI<TaskListStore>();
export { Provider as TaskListProvider, use as useTaskListStore };

/**
 * 作業競合確認画面 状態とアクション
 */
export const defaultTaskListStore = () => {
  const api = useApi();
  // @ts-ignore
  return create<TaskListStore>(() => {
    return {
      checkConflict: async () => {
        const resp = await api.path('/api/conflicts/check').post();
        if (resp.isError) {
          throw new ApiError(resp);
        }
      },
      getConflictStatus: async () => {
        const resp = await api.path('/api/conflicts/check').get();
        if (resp.isError) {
          if (resp.status === 404) {
            return undefined;
          }
          throw new ApiError(resp);
        }
        return resp.data as ConflictStatusResponse;
      },
      searchTaskList: async (param) => {
        const resp = await api.path('/api/works/conflicts?' + toQuery(param)).get();
        if (resp.isError) {
          throw new ApiError(resp);
        }
        return resp.data as ApplicantResponse;
      },
      getConflict: async (conflictId, planId) => {
        const resp = await api.path(`/api/conflicts/${conflictId}/plans/${planId}`).get();
        if (resp.isError) {
          throw new ApiError(resp);
        }
        return resp.data as WorkListReponse;
      },
    };
  });
};
